// extracted by mini-css-extract-plugin
module.exports = {"CheckoutButton":"CheckoutSidebar_CheckoutButton__W1VZw","Root":"CheckoutSidebar_Root__LT_F4","FixedButtonOnMobile":"CheckoutSidebar_FixedButtonOnMobile__RuIvs"};